// vw はクラシックスクロールバーが表示されていても「存在しないもの」として
// 計算されるため、100vw と実際のコンテンツ幅はスクロールバー幅ぶんずれる。
// 実測値を CSS 変数に渡し、方眼セル幅 --grid-cell の計算(global.css)で
// 差し引く。scrollbar-gutter: stable なのでスクロールの有無では変動せず、
// 初回とリサイズ時の計測だけで安定する
const setScrollbarWidth = () => {
  document.documentElement.style.setProperty(
    '--scrollbar-w',
    `${window.innerWidth - document.documentElement.clientWidth}px`,
  );
};

setScrollbarWidth();
window.addEventListener('resize', setScrollbarWidth);
